var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '@shared/commons/DataCache';
import { Resources } from '@shared/localizations/Resources';
import { CloseAccountResponseStatus } from '@shared/utils/Enums/Constants';
import { MessageBoxType } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from './TerceraMessageBox';
export class CloseAccountScreen {
    static ShowMsg(isInvesting = false) {
        if (DataCache.closeAccountApproved) {
            CloseAccountScreen.ShowApproveCloseAccountScreen(); // The approval screen will be displayed if the 'CloseAccountScreen' was opened or on the next click of the 'Close account' menu item.
            return;
        }
        const requestSent = DataCache.closeAccountRequestID > 0;
        const additionalData = {
            style_addition_header: '',
            okText: requestSent
                ? Resources.getResource('screen.closeAccount.cancelText')
                : Resources.getResource('screen.closeAccount.okBtnText'),
            cancelText: Resources.getResource('screen.closeAccount.closeBtnText')
        };
        if (isInvesting) {
            if (requestSent) {
                DataCache.SendCloseAccountCancelRequestMessage(DataCache.closeAccountRequestID);
            }
            else {
                DataCache.SendCloseAccountRequestMessage();
            }
            return;
        }
        if (!isInvesting && !CloseAccountScreen.subscribedToChangeRequestIDEvent) {
            DataCache.OnChangeCloseAccountRequestID.Subscribe(CloseAccountScreen.OnChangeCloseAccountRequestID.bind(this), this);
            CloseAccountScreen.subscribedToChangeRequestIDEvent = true;
        }
        CloseAccountScreen.messageBoxHandler = TerceraMessageBox.Show(Resources.getResource('screen.closeAccount.header'), Resources.getResource(requestSent ? 'screen.closeAccount.submitText' : 'screen.closeAccount.confirmText'), MessageBoxType.YellowInfo, CloseAccountScreen.SendRequestHandler, () => { }, false, false, null, additionalData, false);
    }
    static OnChangeCloseAccountRequestID(message) {
        const approved = message.status === CloseAccountResponseStatus.Approve;
        const msgBox = CloseAccountScreen.messageBoxHandler;
        if (msgBox === null || msgBox.torndown) {
            // Will not show the 'Approve Close Account' screen if this screen was closed, but it will recognize the received approval in order to display it the next time it is opened.
            // return;
        }
        msgBox === null || msgBox === void 0 ? void 0 : msgBox.dispose(); // better use msgBox.close() (but ESLint: property 'close' does not exist on type 'TerceraMessageBox'.) Can use onCloseButtonClick();
        if (approved) {
            CloseAccountScreen.ShowApproveCloseAccountScreen();
        }
        else {
            CloseAccountScreen.ShowMsg();
        }
    }
    static SendRequestHandler() {
        return __awaiter(this, void 0, void 0, function* () {
            const reqID = DataCache.closeAccountRequestID;
            const needToCancelRequest = reqID > 0;
            const msgs = needToCancelRequest
                ? yield DataCache.SendCloseAccountCancelRequestMessage(reqID)
                : yield DataCache.SendCloseAccountRequestMessage();
            if ((msgs === null || msgs === void 0 ? void 0 : msgs.length) > 0) {
                const msg = msgs[0];
                if (msg !== undefined) {
                    switch (msg.status) {
                        case CloseAccountResponseStatus.New:
                            if (CloseAccountScreen.messageBoxHandler == null) {
                                CloseAccountScreen.messageBoxHandler = TerceraMessageBox.Show(Resources.getResource('screen.closeAccount.header'), // <-header,
                                Resources.getResource('screen.closeAccount.submitText'), MessageBoxType.YellowInfo, CloseAccountScreen.SendRequestHandler, () => { }, false, false, null, {
                                    style_addition_header: '',
                                    okText: Resources.getResource('screen.closeAccount.cancelText'),
                                    cancelText: Resources.getResource('screen.closeAccount.closeBtnText') // <-close button text
                                }, false);
                            }
                            break;
                        case CloseAccountResponseStatus.Approve:
                            CloseAccountScreen.ShowApproveCloseAccountScreen();
                            break;
                        case CloseAccountResponseStatus.Rejected:
                        case CloseAccountResponseStatus.Cancelled:
                            CloseAccountScreen.ShowMsg();
                            break;
                    }
                }
            }
        });
    }
    static ShowApproveCloseAccountScreen() {
        CloseAccountScreen.messageBoxHandler = TerceraMessageBox.Show(Resources.getResource('screen.closeAccount.header'), Resources.getResource('screen.closeAccount.approveText'), MessageBoxType.Approve, () => { }, () => { }, false, true, null, { style_addition_header: '', okText: Resources.getResource('screen.closeAccount.closeBtnText') }, false);
    }
}
CloseAccountScreen.messageBoxHandler = null;
CloseAccountScreen.subscribedToChangeRequestIDEvent = false;
